import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Tab, Nav, Button, Card, Modal, OverlayTrigger, Tooltip, TabPane, Dropdown, NavDropdown, Table } from 'react-bootstrap';
import HeaderNew from '../../components/HeaderNew';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from '../../app/Courses/styles/course1.js';
import service, { URI } from '../../services/service';
import UserService from '../../services/UserService';
import ReplyForm, { Replyform } from './components/ReplyForm';
import UpdateReviewform from './components/UpdateReviewForm';
import { Styles2 } from '../courses/styles/courseAccordian.js';
import { useHistory } from 'react-router-dom';
import RenderOnAuthenticated from '../account/RenderOnAuthenticated';
import RenderOnAnonymous from '../account/RenderOnAnonymous';
import swal from 'sweetalert';
import { useSelector, useDispatch } from 'react-redux';
import Modal1 from "react-modal";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
import Toast from 'react-bootstrap/Toast';
import { Spinner } from 'react-bootstrap';
import CourseFeedback from '../account/CourseFeedback';
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import learnerService from '../../services/learnerService';
import instructorService from '../../services/instructorService';
import Videojs from '../../pages/instructor/instCourses/video'
import ModalVideo from 'react-modal-video';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import EnrolledAssignment from './enrolledAssignment/EnrolledAssignment'
import moment from 'moment';
import { colors } from "../../components/common/element/elements.js";
import Query from '../courses/Query/Query';
import fileDownload from 'js-file-download';
import CourseFeedbackList from '../account/CourseFeedbackList';
import CryptoJS from "crypto-js";
import useNonce from '../../helper/Nonce.js';
import { sortedUniq } from 'lodash';
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { Circles } from 'react-loader-spinner';
import { BsTwitterX } from 'react-icons/bs';
import { LearnerCourseWiseContentWatchStatus } from '../dashboard/DashboardModals.js';
import adminServices from '../../services/adminServices.js';
import ProgressBar from "@ramonak/react-progress-bar";
import "./CourseDetailsNFSU.css";
import CourseDetailsNFSU from './CourseDetailsNFSU.js';
import CourseSection from '../../components/CourseSection.js';
import CourseSectionCD from '../../components/CourseSectionCD.js';
import RegistrationIcon from './../../assets/images/registration.png';
import VerificationIcon from './../../assets/images/verification.png';
import CourseIcon from './../../assets/images/course.png';
import PaymentIcon from './../../assets/images/payment.png';
import LearningIcon from './../../assets/images/learning.png';
import "./CourseDetailsNFSU.css";

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
]

function CourseDetailsNFSUbeforeLogin(props) {

    useEffect(() => {
        UserService.generateToken();
    }, []);

    let courseID = props.match.params.id;
    let tenantID = props.match.params.tid;

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()

    // const fetchAndSetNonce = useNonce();
    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])
    Modal1.setAppElement('*');
    const history = useHistory();

       let status = props.match.params.status;
       let mainurl = `${URI.SERVER?._FRONTEND_UI}/course-details/`;
       let url = mainurl + courseID + '/' + tenantID+'/'+status;

    const stepData = [
        { icon: RegistrationIcon, label: "Registration" },
        { icon: VerificationIcon, label: "Verification" },
        { icon: CourseIcon, label: "Choose your course" },
        { icon: PaymentIcon, label: "Fee Payment" },
        { icon: LearningIcon, label: "Start Learning" },
    ];

    // //console.log("tenantId in course details file" + tenantId);
    const um_api = URI.SERVER?._USER_API;
    //console.log(um_api);
    // const dms_url = instructorService.URI.SERVER?._DMS_URL;
    ////// 

    const [courseId, setDecodedCourseId] = useState(null)
    const [tenantId, setDecodedTenantId] = useState(null)

    const [isDecodeValid, setIsDecodeValid] = useState("NOTVALID")

    const decodeHandler = () => {

        const secretKey = "cdac@123"

        const encodedCourseId = props.match.params.id.replace(/-/g, "+").replace(/_/g, "/");
        const decodedCourseId = CryptoJS.AES.decrypt(
            encodedCourseId,
            secretKey
        ).toString(CryptoJS.enc.Utf8);

        const encodedTenantId = props.match.params.tid.replace(/-/g, "+").replace(/_/g, "/");
        const decodedTenantId = CryptoJS.AES.decrypt(
            encodedTenantId,
            secretKey
        ).toString(CryptoJS.enc.Utf8);

        const regex = /^[0-9]+$/

        const isValidCourseId = regex.test(decodedCourseId)
        const isValidTenantId = regex.test(decodedTenantId)

        if (isValidCourseId && isValidTenantId) {
            setIsDecodeValid("VALID")
            setDecodedCourseId(decodedCourseId)
            setDecodedTenantId(decodedTenantId)
        }
        else {
            setIsDecodeValid("NOTVALID")

            swal({
                title: t('something_went_wrong_try_later'),
                text: t('redirecting_to_course_list'),
                timer: 5000,
            }).then(() => {
                history.push(`${process.env.PUBLIC_URL + "/course-grid/"}`);
            })
        }

    }
    const [showContentDependOnDate, ContentDependOnDate] = useState(false);

    useEffect(() => {

        //console.log("Called isDecodeValid")

        if (isDecodeValid !== "VALID") {
            decodeHandler()
        }

    }, [isDecodeValid])

    const initialStateId = {
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        gender: '',
        dob: '',
        instituteName: '',
        eduQualification: '',
        address: '',
        city: '',
        pincode: '',
        countryId: '',
        stateId: '',
        districtId: '',
        updateBy: props.match.params.updateBy,
        learnerUsername: props.match.params.learnerUsername,
        firstNameError: '',
        lastNameError: '',
        genderError: '',
        dobError: '',
        mobileError: '',
        eduQualificationError: '',
        instituteNameError: '',
        addressError: '',
        cityError: '',
        pincodeError: '',
        countryIdError: '',
        stateIdError: '',
        districtIdError: '',
        facebookId: '',
        twitterId: '',
        linkedinId: '',
        youtubeId: '',
        skypeId: '',
        facebookIdError: '',
        twitterIdError: '',
        linkedinIdError: '',
        youtubeIdError: '',
        skypeIdError: ''
    };

    const paymentinitialualue = {
        merchant_param1: "",
        merchant_param2: "",
        merchant_param3: "",
        merchant_param4: "",
        merchant_param5: "",
        promo_code: "",
        merchant_param1err: "",
        merchant_param2err: "",
        merchant_param3err: "",
        merchant_param4err: "",
        merchant_param5err: "",
    }


    // const [toggle, setToggle] = useState(false);
    const [check, setCheck] = useState(0)
    const [courseValue, setCourseValue] = useState([]);
    const [visibility, setVisibility] = useState(true);
    const [reviewvisibility, setReviewVisibility] = useState(false);
    const [reviewvisibilitybfrlgin, setreviewvisibilitybfrlgin] = useState(false);
    const [getcourseStructure, setcourseStructure] = useState([]);
    const [getcourseStructure1, setcourseStructure1] = useState([])
    const [assessDetails, setAssessDetails] = useState([]);
    const [getCourseAnnouncement, setCourseAnnouncement] = useState([]);
    const [apiError, setApiError] = useState();
    const [msg, setmsg] = useState();
    const [msgshow, setMsgShow] = useState(true);
    const [getCertiStatus, setCertiStatus] = useState();
    const [getCertificateURl, setCertificateURL] = useState();
    const [getInstructor, setInstructor] = useState([]);
    const [getViewModalState, setViewModalState] = useState();
    const [getServerTime, setServerTime] = useState();
    const [number, setNumber] = useState();
    const [getInstCourseStatus, setInstCourseStatus] = useState();
    const [userCount, setUserCount] = useState();
    const [feeStatus, setFeesStatus] = useState(false);
    const [getUserDetails, setUserDetails] = useState(initialStateId);
    const [getRating, setRating] = useState([]);
    const [getPaymentInfo, setPaymentInfo] = useState(paymentinitialualue);
    const [getPageLoading, setPageLoading] = useState(false);
    const [userCourseScheduleData, setUserCourseScheduleData] = useState(null);
    const [getUserProgress, setUserProgress] = useState({
        progress: 0,
        progressStatus: "NOTCOMPLETED",
        certDownloadStatus: "NOTGENERATED"
    })
    const [prerequisiteCourses, setPrerequisiteCourses] = useState({
        showModal: false,
        data: []
    })

    useEffect(() => {
        const timeout = setTimeout(() => {
            setPageLoading(false);
            // scrollWin()
        }, 1500); // 1.5 seconds timeout

        return () => clearTimeout(timeout); // Clean up timeout on component unmount
    }, []);
    useEffect(() => {
        setPageLoading(true)
        if (isDecodeValid === "VALID") {
            courseMetaData();
            callCourseDelievery();
            if (userId) {
                getEnrollmentStatus();
            }
            if (UserService.isLoggedIn()) {
                getCertificateSatus(courseId);
                getUserTenantCourseDetails();
                getUserById();
                announcementCourse();
                getbyCourseIdandUserId();
                paymentDetailsStatus();
                UserCourseProgressByUserIdandCourseId();
            }
            courseStructureById();
            serverTime();
            noOfUser();

            const accordionButton = document.querySelectorAll(".accordion-button");
            accordionButton.forEach(button => {
                button.addEventListener("click", () => {
                    button.classList.toggle("active");
                    const content = button.nextElementSibling;

                    if (button.classList.contains("active")) {
                        content.className = "accordion-content show";
                        content.style.maxHeight = content.scrollHeight + "px";
                    } else {
                        content.className = "accordion-content";
                        content.style.maxHeight = "0";
                    }
                });
            });
        }

    }, [isDecodeValid, courseId])

    useEffect(() => {
        if (UserService.isLoggedIn()) {
            let rating = [{
                itemId: courseId,
                reviewType: 1,
                tenantId: 1
            }]
            //console.log(rating);

            service.averageRating(rating)
                .then(res => {
                    setAvgRating(res.data);
                    // 
                    //console.log(res.data);
                }).catch(error => {
                    // 
                    //console.log(('service_maintainance_down_alert'))
                }
                );
        }
    }, [getRating, courseId])

    const courseMetaData = () => {
        learnerService.getCourseMetadataById(courseId)
            .then(res => {

                setCourseValue(JSON.parse(res.data));
            }).catch(err => {
                swal({
                    title: t('service_maintainance_down_alert'),
                    text: t('redirect_course_list'),
                    timer: 5000,

                }).then(() => {
                    history.push(`${process.env.PUBLIC_URL + "/course-grid/"}`);
                })
            })
    }

    const [getCrtStatus, seCrtStatus] = useState();

    const getCertificateSatus = (course) => {
        instructorService.getCertificateStatus(course)
            .then((res) => {
                seCrtStatus(res.data);
            }).catch((err) => {
            })

    }

    const getUserTenantCourseDetails = () => {
        learnerService.getUserTenantCourseDetails(courseId, tenantId)
            .then((res) => {
                setUserCourseScheduleData(res.data);
                if (res.data === "") {
                    setUserCourseScheduleData(null)
                }
            })
            .catch((err) => {
                // swal({
                //     title: t('service_maintainance_down_alert'),
                //     text: t('redirect_course_list'),
                //     timer: 5000,

                // }).then(() => {
                //     history.push(`${process.env.PUBLIC_URL + "/course-grid/"}`);
                // })
            })
    }

    const getEnrollmentStatus = () => {

        //console.log("calling getEnrollmentStatus API with courseId", courseId, "tenantId", tenantId)

        service.getUserEnrollmentStatus(courseId, userId, 1, tenantId)
            .then(res => {
                //console.log();

                if (res.data.courseEnrolled === true) {
                    setVisibility(false);
                }
                setInstCourseStatus(res.data.instCourseStatus);
                //console.log()
                //setCertiStatus(res.data.certificateGenerated);
            })
            .catch(err => {

                //setmsg(t('service_maintainance_down_alert'));
                //console.log('service_maintainance_down_alert');
            })
    }

    const courseStructureById = () => {


        learnerService.getCourseStructureById(courseId)
            .then(res => {
                if (res.data == "Course Structure is yet to publish") {
                    swal(t('msg'), t('plz_wait'), "warning");
                }
                else {
                    setcourseStructure(res.data);
                    setcourseStructure1(res.data.nodes);
                }

            }).catch(err => {
                setmsg(t('service_maintainance_down_alert'));
            })
    }

    const serverTime = () => {


        instructorService.getServerTime()
            .then(res => {
                let serTime = res.data;
                
                setServerTime(serTime.replace(/\s/g, 'T'))
            })
    }

    const noOfUser = () => {


        service.userCount(courseId, tenantId)
            .then(res => {

                setUserCount(res.data.userCount);
            }).catch(error => {
            })
    }

    const announcementCourse = () => {


        service.courseAnnouncement(courseId, tenantId)
            .then(res => {

                setCourseAnnouncement(res.data);
            }).catch(error => {

                setmsg(t('service_maintainance_down_alert'))
            });
    }

    const getUserById = () => {


        service.getUserById(userId)
            .then(res => {

                setUserDetails(res.data);
            })
            .catch(err => {

            });
    }

    const UserCourseProgressByUserIdandCourseId = () => {

        adminServices.getUserCourseProgressByUserIdandCourseId(courseId, userId)
            .then(res => {
                setUserProgress({
                    progress: res.data.progress,
                    progressStatus: res.data.progressStatus,
                    certDownloadStatus: res.data.certDownloadStatus
                });

            }).catch(err => {

            })

    }

    const paymentDetailsStatus = () => {


        service.getPaymentDetails(userId, courseId, 1)
            .then(res => {

                if (res.data.status === "paid") {
                    setFeesStatus(true);
                }
                else {
                    setFeesStatus(false);
                }
            })
            .catch(err => {

            });
    }


    const [roleId, setRoleId] = useState("");

    const getbyCourseIdandUserId = () => {


        if (userId !== " ") {
            service.getRoleIdbyCourseIdandUserId(courseId, userId)
                .then((res) => {
                  
                    if (res.status === 200) {
                        setRoleId(res.data);
                      
                    }
                    else {
                       
                    }
                })
                .catch((err) => {
                    
                })
        }
    }


    let [certificateViewButton2, setCertificateViewButton2] = useState(true);
    let [certificateViewButton, setCertificateViewButton] = useState(false);
    let [statusCer, setStatusCer] = useState(false);

    const getQuizzesStatus = async (userId, courseId) => {
        await learnerService.getAssignedQuizzesStatus(userId, courseId)
            .then(res => {
                res.data.assignedQuizzes.map((data) => {

                    if (res.data.assignedQuizzes.length == 0) {
                        setCertificateViewButton(true);
                        setStatusCer(true);
                    }
                    else {
                        res.data.assignedQuizzes.map((data) => {
                            if (data.isPassed === true) {
                                setCertificateViewButton(true);
                                setStatusCer(true);
                               
                            }
                            else {
                                setCertificateViewButton2(false);
                            }
                           
                        })
                    }
                   
                })

            })
            .catch(err => {
            })
    }

    useEffect(() => {

        if (isDecodeValid === "VALID") {

            if (UserService.isLoggedIn()) {
                getQuizzesStatus(userId, courseId);
            }
            handleContentDependOnDate();
            instructorData();
        }

    }, [isDecodeValid, statusCer, courseId, showContentDependOnDate])

    useEffect(() => {

        if (isDecodeValid === "VALID") {

            handleContentDependOnDate();
        }

    }, [courseId, showContentDependOnDate])



    // const convertDate = (dateFormat) => {
    //     let timestamp = Date.parse(dateFormat);
    //     let d = new Intl.DateTimeFormat('en-in', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(timestamp);
    //     return d;
    // }

    const convertDateAndTime = (dateFormat) => {
        // //console.log(dateFormat);
        let timestamp = Date.parse(dateFormat);
        let date = new Date(timestamp);
        let d = date?.toLocaleString('en-IN', {
            hour12: false,
            timeZone: 'Asia/Kolkata'
        });
        // let d = new Intl.DateTimeFormat('en-in', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(timestamp);
        return d;
    }

    const convertDate = (dateFormat) => {
        let timestamp = Date.parse(dateFormat);
        let date = new Date(timestamp);

        // Return only date (DD/MM/YYYY format for en-IN)
        return date.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' });
    }


    let RESTRICTED = "Restricted"
    const fee_validator = (fees, courseType, foreignFees) => {
        if (courseType === "free") {
            return "Free Course"
        }
        else if (courseType === "paid") {
            return <div>&#8377;{fees} {foreignFees > 0 && <span> / &#0036;{foreignFees}</span>}</div>
        }
        else {
            return <div>{RESTRICTED}</div>
        }
    }

    const [CourseEnrollment, setCourseEnrollment] = useState({
        isLoading: false
    })

    const [getModalState2, setModalState2] = useState({
        show: false,
        path: "",
        id: ""
    })
    const [getModalState5, setModalState5] = useState({
        show: false,
        path: ""
    })

    const customStyles1 = {
        content: {
            position: 'fixed',
            left: 2,
            right: 2,
            top: 2,
            bottom: 2,
            background: 'none',
            backgroundColor: 'white',
            padding: '0px',
        },
    };


    const enrollCourseHandler = () => {
        setCourseEnrollment({ isLoading: true });
        const courseEndDate = courseValue.closingDate;
        let data = {
            "courseId": courseId,
            "tenantId": tenantId,
            "userId": userId,

            // "certificateId": " ",
            // "certificateIssuedDate": " ",
            // "completionDate": " ",
            // //"courseEndDate": d.toISOString(courseValue.closingDate),
            // "courseEndDate": dCourseEnd.toISOString(),
            // "courseProgress": "in-progress",
            // //"courseStartDate": d.toISOString(courseValue.commencementDate),
            // "courseStartDate": dCourseStart.toISOString(),
            // "id": {
            //     "courseId": courseId,
            //     "roleId": 4,
            //     "tenantId": tenantId,
            //     "userId": userId
            // },
            // "suspendAll": 1,
            // "enrollReqDate":denrollReqDate.toISOString()
        }
        //console.log(data);
        //console.log(courseValue);
        if (service.postUserEnrollment(data)
            .then(res => {
                if (res.data == "Course enrollment date is already passed") {
                    //console.log(res.data)
                    Swal.fire({
                        title: t('Enrollmanet Closed'),
                        text: t('Enrollment date has passed'),
                        icon: "error",
                        showConfirmButton: false,
                        timer: 5000
                    }).then(() => {
                        setVisibility(false);
                        window.location.reload();
                        setCourseEnrollment({ isLoading: false });
                    })
                    // swal(t('Enrollmanet Closed'), t('Enrollment date has passed'), "error");
                }
                else if (res.status == 200) {
                    Swal.fire({
                        title: t('course_enrolled_successfully'),
                        text: t('course_enrolled_successfully_alert'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 5000
                    }).then(() => {
                        setVisibility(false);
                        // window.location.reload();
                        setCourseEnrollment({ isLoading: false });
                    })
                }
                else if (res.status == 208) {
                    setPrerequisiteCourses((prev) => {
                        return {
                            ...prev,
                            showModal: true,
                            data: res?.data
                        }
                    })
                    // Swal.fire({
                    //     html: `
                    //         <p >These course need to Complete before Enrolling this course</p>                         
                    //     `,
                    //     icon: "info",
                    //     position: "center",
                    //     width: "50%"
                    //     // html: `
                    //     //     <table class="table table-borderless">
                    //     //         <tbody>
                    //     //             <tr>
                    //     //                 <td>Name</td>
                    //     //                 <td>{ShareUrlModal.firstName} {ShareUrlModal.lastName}</td>
                    //     //             </tr>
                    //     //         <tbody>                            
                    //     //    </table>
                    //     // `
                    // }).then(() => {
                    //     setVisibility(false);
                    //     // window.location.reload();
                    //     setCourseEnrollment({ isLoading: false });
                    // })
                }
            })
            .catch(err => {
                //console.log(err);
                setCourseEnrollment({ isLoading: false });
            })) {
        }
    }

    const paymentValidations = () => {

        let status = true;
        let merchant_param1err = "";
        let merchant_param2err = "";
        let merchant_param3err = "";
        let merchant_param4err = "";
        let merchant_param5err = "";

        if (getPaymentInfo.merchant_param1.match(/^[A-Za-z0-9 \s]{0,100}$/)) {
            //status = true;
        } else {
            merchant_param1err = "Words and numbers are allowed(max 100 letters)";
            status = false;
        }

        if (getPaymentInfo.merchant_param2.match(/^[A-Za-z0-9 \s]{0,100}$/)) {
            // setPaymentInfo({ ...getPaymentInfo, merchant_param2err:""});
            //status = true;
        } else {
            merchant_param2err = "Words and numbers are allowed(max 100 letters)";
            status = false;
        }

        if (getPaymentInfo.merchant_param3.match(/^[A-Za-z0-9 \s]{0,100}$/)) {
            setPaymentInfo({ ...getPaymentInfo, merchant_param3err: "" });
            //status = true;
        } else {
            merchant_param3err = "Words and numbers are allowed(max 100 letters)";
            status = false;
        }

        if (getPaymentInfo.merchant_param4.match(/^[A-Za-z0-9 \s]{0,100}$/)) {
            setPaymentInfo({ ...getPaymentInfo, merchant_param4err: "" });
            //status = true;
        } else {
            merchant_param4err = "Words and numbers are allowed(max 100 letters)";
            status = false;
        }

        if (getPaymentInfo.merchant_param5.match(/^[A-Za-z0-9 \s]{0,100}$/)) {
            setPaymentInfo({ ...getPaymentInfo, merchant_param5err: "" });
            //status = true;
        } else {
            merchant_param5err = "Words and numbers are allowed(max 100 letters)";
            status = false;
        }

        if (status == false) {

            setPaymentInfo(prevInfo => ({
                ...prevInfo,
                merchant_param1err: merchant_param1err,
                merchant_param2err: merchant_param2err,
                merchant_param3err: merchant_param3err,
                merchant_param4err: merchant_param4err,
                merchant_param5err: merchant_param5err,
            }));

            return false;
        }
        else {
            return true;
        }
    }

    const paymentForCourse = async (courseId, tenantId) => {

        let status = paymentValidations();

        let data = {
            courseId: courseId,
            userId: userId,
            tenantId: tenantId,
            // currencyType: getPaymentInfo.currencyType,
            merchant_param1: getPaymentInfo.merchant_param1,
            merchant_param2: getPaymentInfo.merchant_param2,
            merchant_param3: getPaymentInfo.merchant_param3,
            merchant_param4: getPaymentInfo.merchant_param4,
            merchant_param5: getPaymentInfo.merchant_param5,
            promo_code: getPaymentInfo.promo_code
        };



        if (status == true) {

            await service
                .paymentDetailSave(data)
                .then((res) => {



                    const TokenJsonString = JSON.stringify(res.data);
                    //  let encoded = encodeURIComponent(res.data);
                    // //setOrderId(res.data.orderId)


                    const form = document.createElement("form");
                    form.method = "post";
                    // form.action = 'http://10.244.0.231:8080/cdachydpaymentgateway/pg/client/initPay';

                    // Testing purpose
                    // form.action = "https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction";

                    // Production purpose
                    form.action = "https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction";

                    //  form.action = `https://apitest.ccavenue.com/apis/servlet/DoWebTrans?enc_request=${res.data.encRequest}&access_code=${res.data.access_code}&request_type=JSON&response_type=JSON&command=orderStatusTracker&version=1.2`;
                    //  form.action = `https://apitest.ccavenue.com/apis/servlet/DoWebTrans?enc_request=${res.data.encRequest}&access_code=${res.data.access_code}&request_type=XML&response_type=XML&command=confirmOrder&version=1.1`;


                    const hiddenField = document.createElement("input");
                    hiddenField.type = "hidden";
                    hiddenField.name = "encRequest";
                    hiddenField.id = "encRequest";
                    hiddenField.value = res.data.encRequest;


                    const hiddenField1 = document.createElement("input");
                    hiddenField1.type = "hidden";
                    hiddenField1.name = "access_code";
                    hiddenField1.id = "access_code";
                    hiddenField1.value = res.data.access_code;

                    //hiddenField.value = "{ clientId : cdac.hyd.chariot, requestToken : eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..4il_-eohyxyjSmXQy0ygBw.GRZZ5I7we8wwEB9eXEbxBZP6EPjhf3V5PY2x92bufA0-jEZtf-R8HHIUDoFz4qXFTRPKsNMzVXAZwU_EJEBJ_fYfPAjCibnZRZQHGT_995QBPVrCUmGcOIXf79C7bpUmIh4hDFXRFXvLKenBLJbicE-1Fae675oThqiYZZ2pzdPsAcaPrwZPsiYTvnpIVyp3saO0h3kk3bhsPo_pQF_8t9Ok3HSBqv-fs3LELEbsrqAQE_Z_ms4YEi0fRG6uW6M3Jr--s2kGuZF1Zsi-4nNcsht_NvylhqwIV6ObPJqinHjiqpYrv0wEheQpsG-zkf04lcyTUpMHLRWZpk4uVOvHdaWNdI8uuTm0_0W4TOZPOMrrKLszDgcOLU64mJedd6i-kOXIL2Kw9oOyX9eh1xQXnpbdR5owwh-Yd4COo1xKJOTgNiDUPoYDlgMhfBkIp1zwgXtQo66i6dBeaFo6XkTzwrXlenRwW1N9UMVjQqpjHVZniS_3CBfWgdN64TsJDo5JeFOc1icD00bWFulw9ir6YqV9CWcFi8_Jiu51PTRsZ14.-qcJIb3Zpe2irwqwcln5pg}";
                    // hiddenField.value = "{ clientId : cdac.hyd.chariot, requestToken : eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..KUkdrntsDut5As8X6qkPEg.IyVfYSS3X2w5ybBpSyICSUnXczfRwPdkiNFvGPIySGLVhw_yWEnlL_ei2KyfsnkOeIdI-8kkEpQ0yPtu0iWQ1QeqeegR_boGBNnT9I_xM2zUyg5ICjxefaf0ZPfCyCygQmZGGxuiCEzIgNRsfSRr8Onyu5EGemFuQb2QzeRg-ZBipi-VRlk__cBIwchy2OW3JjGmf4AkplroOiYqJVtzEOzx0fQVLSrupfCHO5vMmCP2QdFZLc5jcJ1AuNSRXcAgCnVJlm2afw4nYlzwdLT5Ce1chS6qQBMLpOxUMs7qtKEVw5KpFbras9mPM4AQZEwpZxY_9C7BV9zY-VqP0UV67EXkedskftfUUXH_CIDgq1jKvKgebAEwB2_wt1_kkQ0tlu0WO4hGx27TszGlgMUHYL7xQDv_89ByxMXlJcxcUhfxcgOjhDTcA1_23tsLDjH1ZIy9JnQGhIoU48z1H4OWL5ArfRx21lKheo4UB94nkCXnkMvGF6NaUkRtTFJKFi22RvKpZ_M5hkMvzCImEw9xH2i8NAl-VE3le4RwFker17A.I7P1Yh79WgOout1tjd3GgQ}";

                    form.appendChild(hiddenField);
                    form.appendChild(hiddenField1);
                    document.body.appendChild(form);
                    form.submit();
                })
                .catch((err) => {
                });

        }

    };

    const [getModalState, setModalState] = useState({
        show: false
    })


    const [getModalState1, setModalState1] = useState({
        show: false
    })

    const [getcourseId, setCourseId] = useState(0);

    const [getreviewText, setReviewText] = useState(0)
    const [getreviewId, setreviewId] = useState(0)
    const [getureviewId, setureviewId] = useState(0)

    const [getstarrate, setstarrate] = useState(0)
    let userId = UserService.getUserid();
    let username = UserService.getUsername();
    let userEmail = UserService.getEmail();
    let id = 12;

    let reviewId = { getreviewId }





    const state = {
        rating: '',
        reviewText: '',
        learnerId: userId,
        itemId: courseId,
        reviewStatus: 'Done',
        reviewType: 1,
        ratingError: '',
        reviewTextError: '',
        tenantId: tenantId,

    }

    const [getRate, setRate] = useState(state);

    const validate = () => {
        let ratingError = '';
        let reviewTextError = '';
        if (!getRate.rating) {
            ratingError = t('rating_cannot_be_blank');
        }
        if (ratingError != '') {
            setRate({ ...getRate, ratingError });
            return false;
        }
        if (!getRate.reviewText) {
            reviewTextError = t('comment_cant_be_blank');
        }
        if (reviewTextError != '') {
            setRate({ ...getRate, reviewTextError });
            return false;
        }
        return true;
    }

    const [loading, setLoading] = useState();
    const saverating = async () => {
        //await fetchAndSetNonce();
        if (validate()) {
            setLoading(true);
            let review = { rating: getRate.rating, reviewText: getRate.reviewText, learnerId: getRate.learnerId, itemId: courseId, reviewStatus: getRate.reviewStatus, reviewType: getRate.reviewType, tenantId: 1, reviewId: 0 };
            service.createrating(review).then(async response => {
                setLoading(false);
                await swal(t('review_submited_succesfully'), t('review_submited_succesfully_alert'), "success");
                getOverAllRating();
            }).catch(err => {
                setLoading(false);

            });
        }
    }


    useEffect(() => {
        const courseButton = document.querySelectorAll(".course-button");
        courseButton.forEach(button => {
            button.addEventListener("click", () => {
                button.classList.toggle("active");
                const content = button.nextElementSibling;

                if (button.classList.contains("active")) {
                    content.className = "course-content-cd show";
                    content.style.maxHeight = content.scrollHeight + "px";
                } else {
                    content.className = "course-content-cd";
                    content.style.maxHeight = "0";
                }
            });
        });

        getOverAllRating();

        if (UserService.isLoggedIn()) {
            getOverAllRating();
        }

    }, [courseId]);

    const [reviewTextBoxCondition, setReviewTextBoxCondition] = useState(true);



    const getOverAllRating = () => {
        service.getRatingByItemIdReviewTypeTenantId(courseId, tenantId, 1)
            .then(res => {
                res.data.map((t) => {
                   
                    if (t.learnerUsername === UserService.getUserid()) {
                        setReviewTextBoxCondition(false);
                    }
                })
                setRating(res.data.filter(function (ele) {
                    return ele.tenantId == tenantId
                }))
                _checkthis(res.data);
            })
            .catch(err => {

                setReviewTextBoxCondition(true);
            })
    }

    function _checkthis(_thisrating) {
        {
            _thisrating.map((item) => {
                if (item.learnerId == userId) {
                    setReviewVisibility(true);
                }
                if (userId == undefined) {
                    setreviewvisibilitybfrlgin(true);
                }
            })
        }
    }
    const handleModal = (rrId) => {
        setModalState({ show: true })
        setreviewId(rrId);
        //alert("reviewID:::::" + rrId);
    }

    const handleModal2 = () => {
        setModalState({ show: false })
    }

    const handleModal3 = () => {
        setModalState1({ show: false })
    }
    const handleModal4 = () => {
        setModalState2({ show: false })
    }

    const handleModal5 = () => {
        setModalState5({ show: false })
    }



    const UpdateReview = (reviewText, starrating, urid, userId) => {
        // //console.log("starrating:", starrating);
        setModalState1({ show: true })
        setReviewText(reviewText);
        setstarrate(starrating);
        setCourseId(courseId);
        setureviewId(urid);

    }

    const refreshPage = () => {
        //alert("check");
        window.location.reload();
    }



    const DeleteReview = (reviewId) => {
        //setModalState5({ show: true })
        service.deleterating(reviewId)
            .then(async res => {
                await swal(t('review_deleted_successfully'), t('You_can_check_in_the_reviews'), "success");
                refreshPage();
            })
            .catch(err => {

            })
        //swal("Review deleted  Successfully!", "You can check in the  Reviews!", "success");
    }
    //end of review code


    const [show, setShow] = useState(false)

    //scrolling 
    const scrollWin = () => {
        document.getElementById('Main').scrollIntoView({ behavior: 'smooth' })
        //window.scrollTo(0, 290);
    }

    const [getAvgRating, setAvgRating] = useState([]);

    const dateConverter = (dateFormat) => {
        let timeAgo = format(dateFormat, 'en_US');
        return timeAgo;
    }

    const [getAnnouncmentModal, setAnnouncementModal] = useState(false);
    const [announcementData, setAnnouncementData] = useState({
        title: '',
        body: '',
        date: ''
    })
    const AnnouncementModal = (title, body, date) => {
        setAnnouncementData({ title: title, body: body, date: date })
        setAnnouncementModal(true);
    }
    const openFeedback = (typeid, cid) => {
        history.push(`${process.env.PUBLIC_URL + "/feedback/"}${typeid}/${cid}`);
    }

    const certificateDownload = () => {
        axios({
            method: 'post',
            url: `${URI.SERVER?._COURSE_CLUG}/courseCatalogue/certificate?tenantId=${tenantId}&courseId=${courseId}&emailId=${userId}&name=${username}`,
            responseType: 'blob'
        })
            .then((res) => {
                const file = new Blob(
                    [res.data],
                    { type: 'application/pdf' });
                // const fileURL = URL.createObjectURL(file);
                // fileURL.download = "certificate";
                //setCertificateURL(fileURL);
                const url = URL.createObjectURL(file);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${courseValue.courseName} Certificate.pdf`;
                a.click();
            })
    }

    const certificateView = () => {
        setViewModalState(true);
        axios({
            method: 'post',
            url: `${URI.SERVER?._COURSE_CLUG}/courseCatalogue/certificate?tenantId=${tenantId}&courseId=${courseId}&emailId=${userId}&name=${username}`,
            responseType: 'blob'
        })
            .then((res) => {
                const file = new Blob(
                    [res.data],
                    { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                setCertificateURL(fileURL);
            })
    }

    const [getInstructorImg, setInstructorImg] = useState({
        img: um_api + "public/getprofilepic/"
    });

    const instructorData = () => {
        service.getInstructorDetails(courseId, tenantId)
            .then((res) => {
                setInstructor(res.data);
            })
            .catch(err => {

            })
    }

    const [getUrlModal, setUrlModal] = useState({
        show: false
    })
    const UrlModalHide = () => {
        setUrlModal({ show: false })
    }

    const [getPaymentParameterView, setPaymentParameterView] = useState({
        show: false
    });

    const PaymentParameterView = () => {
        setPaymentParameterView({ show: true })
    }

    const [getFileURL, setFileURL] = useState(null);

    const certificateDownloadFunction = (userId, courseId, tenantId) => {

        setFileURL(null);

        learnerService.toGenerateCertificate(userId, courseId, tenantId)
            .then(res => {

                if (res.status == '200') {
                   

                    learnerService.toDownloadCertificate(courseId, res.data)
                        .then(res => {

                            fileDownload(res.data, "Certificate.pdf");
                        })
                        .catch(err => {

                        })
                    
                }

            }).catch(err => {
                swal(t('error_mesg'), t('try_sometimes'), "error");
            })

    }

    // Certificate Modal show and hide
    const handleCertificateView = () => {
        let userId = UserService.getUserid();
        let tenantId = 1;
        certificateDownloadFunction(userId, courseId, tenantId);
        //setCertificateView({ show: true })
    }

    const PaymentParameterViewHide = () => {
        setPaymentParameterView({ show: false })
    }

    const [getUrl, setUrl] = useState();
    const [getContentType, setContentType] = useState();
    const courseStructurContentView = (contentType, fileUrl) => {
        if (contentType == "youtube") {
            setUrl(fileUrl);
            setContentType(contentType);
            setUrlModal({ show: true });
        } else {
            instructorService.contentAccess(URI.SERVER?._DMS_URL + "/" + fileUrl)
                .then(res => {
                    setUrl(res.data);
                    setContentType(contentType);
                    setUrlModal({ show: true });
                    //window.open(URI.SERVER?._DMS_URL+"/" + res.data, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,width=1000,height=1000");
                }).catch(err => {
                    swal(t('error_mesg'), t('try_sometimes'), "error");
                })
        }
    }

    const videoJsOptions = {
        autoplay: false,
        playbackRates: [0.5, 1, 1.25, 1.5, 2],
        width: 1100,
        height: 800,
        controls: true,
        sources: [
            {
                src: `${URI.SERVER?._DMS_URL}/${getUrl}`,
                type: 'video/mp4',
            },
        ]
    };

    const Tree = ({ data }) => (
        <Styles>
            <div className="course-content show">
                <ul class="tree1 list-unstyled">
                    {data && data.map(item => (
                        (visibility || roleId !== 1) ? <li style={{ fontSize: "16px" }}>
                            {item.nodetype == "folder" ?
                                <p style={{ borderBottom: '1px solid #dddddd' }}><span className="play-icon"><i className="las la-book-open"></i>{item.label}&nbsp;&nbsp;</span></p>
                                : null
                            }
                            {item.nodes &&
                                <ul>
                                    {<Tree data={item.nodes} />}
                                </ul>
                            }
                        </li> :
                            // <li style={{ fontSize: "16px" }}>
                            //     {item.nodetype == "folder" ?
                            //         <p style={{ borderBottom: '1px solid #dddddd' }}><span className="play-icon"><i className="las la-book-open"></i>{item.label}&nbsp;&nbsp;</span></p>
                            //         : item.nodetype == "html" ? < span className="play-icon"><i className="lab la-html5" style={{ fontSize: "25px", color: "#e54c21" }}></i> <a href='#' onClick={() => CourseDelivery(courseValue.courseId, 1)}>{item.label}&nbsp;&nbsp; </a> <span className="lecture-duration">{item.duration == undefined ? null : <p>Duration {item.duration}</p>}</span></span>
                            //             : item.nodetype == "png" || item.nodetype == "jpg" ? < span className="play-icon"><i className="las la-image" style={{ fontSize: "25px", color: "#b2b1ff" }}></i> <a href='#' onClick={() => CourseDelivery(courseValue.courseId, 1)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>Duration {item.duration}</p>}</span></span>
                            //                 : item.nodetype == "pdf" ? < span className="play-icon"><i className="las la-file-pdf" style={{ fontSize: "25px", color: "#b30b00" }}></i> <a href='#' onClick={() => CourseDelivery(courseValue.courseId, 1)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>Duration {item.duration}</p>}</span></span>
                            //                     : item.nodetype == "mp4" ? < span className="play-icon"><i className="las la-video" style={{ fontSize: "25px", color: "#8cee02" }}></i> <a href='#' onClick={() => CourseDelivery(courseValue.courseId, 1)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>Duration {item.duration}</p>}</span></span>
                            //                         : item.nodetype == "zip" ? < span className="play-icon"><i className="las la-file-archive" style={{ fontSize: "25px", color: "#fdbf00" }}></i> <a href='#' onClick={() => CourseDelivery(courseValue.courseId, 1)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>Duration {item.duration}</p>}</span></span>
                            //                             : item.nodetype == "scorm" ? < span className="play-icon"><i className="las la-file-archive" style={{ fontSize: "25px", color: "green" }}></i> <a href='#' onClick={() => CourseDelivery(courseValue.courseId, 1)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>Duration {item.duration}</p>}</span></span>
                            //                                 : <span>{item.label}</span>
                            //     }
                            //     {item.nodes &&
                            //         <ul>
                            //             {<Tree data={item.nodes} />}
                            //         </ul>
                            //     }
                            // </li>
                            <li style={{ fontSize: "16px" }}>
                                {item.nodetype == "folder" ?
                                    <p style={{ borderBottom: '1px solid #dddddd' }}><span className="play-icon"><i className="las la-book-open"></i>{item.label}&nbsp;&nbsp;</span></p>
                                    : item.nodetype == "html" ? < span className="play-icon"><i className="lab la-html5" style={{ fontSize: "25px", color: "#e54c21" }}></i> <a href='#' onClick={() => courseStructurContentView(item.nodetype, item.filePath)}>{item.label}&nbsp;&nbsp; </a> <span className="lecture-duration">{item.duration == undefined ? null : <p>{t('duration')} {item.duration}</p>}</span></span>
                                        : item.nodetype == "png" || item.nodetype == "jpg" ? < span className="play-icon"><i className="las la-image" style={{ fontSize: "25px", color: "#b2b1ff" }}></i> <a href='#' onClick={() => courseStructurContentView(item.nodetype, item.filePath)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>{t('duration')} {item.duration}</p>}</span></span>
                                            : item.nodetype == "pdf" ? < span className="play-icon"><i className="las la-file-pdf" style={{ fontSize: "25px", color: "#b30b00" }}></i> <a href='#' onClick={() => courseStructurContentView(item.nodetype, item.filePath)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>{t('duration')} {item.duration}</p>}</span></span>
                                                : item.nodetype == "mp4" ? < span className="play-icon"><i className="las la-video" style={{ fontSize: "25px", color: "#8cee02" }}></i> <a href='#' onClick={() => courseStructurContentView(item.nodetype, item.filePath)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>{t('duration')} {item.duration}</p>}</span></span>
                                                    : item.nodetype == "zip" ? < span className="play-icon"><i className="las la-file-archive" style={{ fontSize: "25px", color: "#fdbf00" }}></i> <a href='#' onClick={() => courseStructurContentView(item.nodetype, item.filePath)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>{t('duration')} {item.duration}</p>}</span></span>
                                                        : item.nodetype == "scorm" ? < span className="play-icon"><i className="las la-file-archive" style={{ fontSize: "25px", color: "green" }}></i> <a href='#' onClick={() => courseStructurContentView(item.nodetype, item.filePath)}>{item.label}&nbsp;&nbsp; </a><span className="lecture-duration">{item.duration == undefined ? null : <p>{t('duration')} {item.duration}</p>}</span></span>
                                                            : <span>{item.label}</span>
                                }
                                {item.nodes &&
                                    <ul>
                                        {<Tree data={item.nodes} />}
                                    </ul>
                                }
                            </li>
                    ))}
                </ul>

            </div>
        </Styles >
    );

    let sTime = getServerTime;
    let cTime = courseValue.closingDate;
    let d1 = new Date(sTime);
    let d2 = new Date(cTime);
    let diffTime = Math.abs(d2.getTime() - d1.getTime());
    let n = new Number(diffTime)
    let arrrr = [
        {
            time: 123132132
        }
    ]


    const toggleHandler = (key) => {
        const updatedCourseStructure = getcourseStructure1.map((singleData, index) => {
            if (singleData.key === key) {
                return { ...singleData, isActive: !(singleData.isActive) }
            }
            return singleData;
        })

        setcourseStructure1(updatedCourseStructure)
    }

    function sumOfAllContentDuration(data) {
        if (data.length === 0) {
            data = "";
            return 0;
        } else {
            var res = data && data.map(d => d.duration).reduce((a, b) => b + a);
            return res;
        }
    }

    function dateCompareFunction(sysDate, enrolmentSDate) {
        

        var sysDate1 = new Date(sysDate);
        var enrolmentSDate1 = new Date(enrolmentSDate);


       

        const x = new Date(sysDate1);
        const y = new Date(enrolmentSDate1);
       
        return (x >= y);
    }



    function getVideoId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url?.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }

    const [fullscreen, setFullscreen] = useState(true);
    const [show2, setShow2] = useState(false);

    function handleShow() {
        setShow2(true);
    }

    const cipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(32)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return text => text.split('')
            .map(textToChars)
            .map(applySaltToChar)
            .map(byteHex)
            .join('');
    }

    const callCourseDelievery = () => {

        
        const condition = handleContentDependOnDate();
        //setToggle(!toggle)
        if (condition === true && visibility !== true && roleId === 1 && (courseValue.courseType === "free" || courseValue.courseType === "restricted" || feeStatus === true)) {
           
            CourseDelivery(courseValue.courseId, 1, courseValue.contentAccessType);
           
        }
    }
    

    const CourseDelivery = (id, tid, contentAccessType) => {

        const secretKey = "cdac@123"

        const encodedCourseId = CryptoJS.AES.encrypt(
            `${id}`,
            secretKey
        ).toString();
        const safeEncodedCourseId = encodedCourseId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");

        const encodedTenantId = CryptoJS.AES.encrypt(
            `${tid}`,
            secretKey
        ).toString();
        const safeEncodedTenantId = encodedTenantId
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
        history.push(`${process.env.PUBLIC_URL + "/ContentDelivery/"}${safeEncodedCourseId}/${safeEncodedTenantId}?contentAccessType=${encodeURIComponent(contentAccessType)}`);
    }

    // data filter depend on end date
    const dateLimitforbutton = moment(userCourseScheduleData === null ? courseValue.closingDate : userCourseScheduleData.enrollmentEndDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    const dateLimit = moment(userCourseScheduleData === null ? courseValue.closingDate : userCourseScheduleData.courseEndDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    const now = moment();
    const handleContentDependOnDate = () => {
        const dateLimit = moment(userCourseScheduleData === null ? courseValue.closingDate : userCourseScheduleData.courseEndDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
        const now = moment();
       
        if (dateLimit.isValid() && dateLimit.isAfter(now)) {
            // ContentDependOnDate(true);
            return true
            showContentDependOnDate = true;
        } // show content if current date is less than end date
    };




    function changeBackgroundOver(e) {
        e.target.style.background = 'linear-gradient(90deg, #009444 0%, #11B67A 100%)';
        e.target.style.border = '0px';
    }

    function changeBackgroundOut(e) {
        e.target.style.background = 'linear-gradient(90deg, #11B67A 0%, #009444 100%)';
        e.target.style.border = '0px';
    }

    const [downloadCertificateicon, setDownloadCertificateicon] = useState(false);

    function changeBackgroundOverCertiButton(e) {
        //e.target.style.background = 'linear-gradient(90deg, #009444 0%, #11B67A 100%)';
        e.target.style.border = '0px';
        setDownloadCertificateicon(true);
    }

    const initialActivityStatus = {
        activityId: "",
        activityProgress: 0,
        activityProgressforDependency: 0,
        dependency: 0,
        status: "Not Completed"
    };
    const [getActivitiesStatus, setActivitiesStatus] = useState(initialActivityStatus);

    const fetchActivitiesStatus = () => {
        if (isDecodeValid === "VALID") {
            service.courseActivitiesStatus(userId, courseId)
                .then(res => {

                    // console.log("This is Activity Course Status", res.data);
                    setActivitiesStatus({ ...res.data });
                })
                .catch(err => {
                    // Handle errors
                    console.error(err);
                });
        }
    };

    useEffect(() => {

        if (UserService.isLoggedIn()) {
            fetchActivitiesStatus();
        }


    }, [courseId]);


    ////////////// CONTENT NOTES ////////////////////

    const [showContentNotes, setShowContentNotes] = useState(false);
    const [showCourseSummary, setShowCourseSummary] = useState(false);

    const handleShowNotesClick = () => {
        setShowContentNotes(true);
    }

    const handleShowCourseSummaryClick = () => {
        setShowCourseSummary(true);
    }

    const prerequisiteCourseColumn = [
        {
            name: "Course Name",
            selector: row => row?.courseName,
            sortable: true,
            // width: "80px"
        },
        {
            name: "Progress",
            selector: row => row?.progress,
            sortable: true,
            // width: "80px"
        },
        {
            name: "Status",
            selector: row => row?.progressStatus,
            sortable: true,
            // width: "80px"
        },

    ]

    const imageState = {
        backgroundImage: 'breadcrumb-bg.png',
    }

    const baseUrl = URI.SERVER?._COURSE_URL?.replace(/\/$/, ""); // remove trailing slash
    const cleanBanner = courseValue?.banner?.replace(/\\/g, "/"); // fix backslashes

    // ✅ don't encode slashes, only fix path
    const bannerUrl = courseValue?.banner
        ? `${baseUrl}/${cleanBanner}`
        : `${process.env.PUBLIC_URL}/assets/images/${imageState.backgroundImage}`;

    /////////// Prerequisite Enrollment Implementation  Modal ////////
    const [openModule, setOpenModule] = useState(null);
    const [openModule2, setOpenModule2] = useState(null);

    const toggleHandlerModule = (key, dIndex, node) => {
        // console.log(key, dIndex);
        // console.log(openModule);
        // console.log(openModule2);
        // console.log("dIndex % 2 == 0", dIndex % 2 == 0);
        // console.log(node.length);

        if(node.length == 0){
            return;
        }
        
        // if (dIndex % 2 == 0) {
        //     setOpenModule2(openModule2 === (dIndex + 1) ? null : (dIndex + 1));
        // }

        // if (dIndex % 2 != 0) {
        //     setOpenModule2(openModule2 === (dIndex - 1) ? null : (dIndex - 1));
        // }

        // setOpenModule(openModule === key ? null : key);
    };

    const handleCourseClick = (status) => {

        //console.log("inside handleCourseClick");

        if (status == true) {
            window.location.reload();
        }
    }

    return (
        <div className="main-wrapper course-details-page">

            < HeaderNew />
            {/* <CourseDetailsNFSU courseid = {courseId} tid = {tenantId}/> */}
            <Styles>
                <div style={{ paddingTop: "140px" }}>

                </div>
                {
                    getPageLoading && <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'White', // Transparent black background
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999, // Ensure it's above all other elements
                        }}
                    >
                        <Circles
                            height={40}
                            width={40}
                            color="#4fa94d"
                            ariaLabel="circles-loading"
                            visible={true}
                        />
                        <span style={{ color: '', marginTop: '20px' }}>Loading, please wait...</span>
                    </div>
                }

                <section
                    className="banner-area-course"
                    style={{ backgroundImage: `url(${bannerUrl})` }}
                >
                    <Container fluid>
                        <Row className="align-items-center">
                            {/* Left side: Video */}
                            <Col md={{span:5, offset:1}} >
                                <div className="course-details-banner">
                                    {courseValue.video ? (
                                        <video
                                            src={process.env.PUBLIC_URL + `${URI.SERVER?._COURSE_URL}/${courseValue.video}`}
                                            alt="Course Video"
                                            className="img-fluid"
                                            controls
                                            controlsList="nodownload noplaybackrate"
                                            disablePictureInPicture
                                            autoPlay
                                            muted
                                        />
                                    ) : (
                                        <img
                                            src={process.env.PUBLIC_URL + `${URI.SERVER?._COURSE_URL}/${courseValue.imageUrl}`}
                                            alt="Course Image"
                                            className="img-fluid"
                                        />
                                    )}
                                </div>
                            </Col>

                            {/* Right side: Course Title + Buttons */}
                            <Col md={6}>
                                <div className="banner-area-box text-left">
                                    <h2 className='course-name-af'>{courseValue?.courseName || "Course Title"}</h2>
                                    <div className="banner-buttons">
                                        <button className="btn btn-danger">
                                            Fully Self-Paced Learning
                                        </button>
                                        <div>
                                            <RenderOnAnonymous>
                                                <button type="button" className="enroll-btn" onClick={UserService.doLogin}>Please Login to <br /> Enroll this Course</button>
                                            </RenderOnAnonymous>
                                            <RenderOnAuthenticated>
                                                {
                                                    (visibility === true && feeStatus == false)
                                                        ?
                                                        ((roleId !== 1 && roleId !== 4 && roleId !== 5 && roleId !== 7)
                                                            ?
                                                            ((dateCompareFunction(getServerTime, courseValue.enrollmentEndDate))
                                                                ?
                                                                <button type="button" className="enroll-btn" disabled={true}>{t('course_enrollment')}</button>
                                                                :
                                                                roleId == 2 ? "" :
                                                                    //(dateLimit.isValid() && dateLimit.isAfter(now)) ?  
                                                                    (dateLimitforbutton.isValid() && dateLimitforbutton.isAfter(getServerTime)) ?
                                                                        // (courseValue.courseFee > 0)
                                                                        //             ?
                                                                        //             <button type="button" onClick={PaymentParameterView} className="enroll-btn" disabled={CourseEnrollment.isLoading ? "true" : ""}>  {CourseEnrollment.isLoading ? (<> {t('loading')}</>) : (<>Pay to Enroll</>)}</button>
                                                                        //             :
                                                                        <button type="button" className="enroll-btn" onClick={() => enrollCourseHandler()} disabled={CourseEnrollment.isLoading ? "true" : ""}>{CourseEnrollment.isLoading ? (<> {t('loading')}</>) : (<>{t('enroll_course')}</>)}</button>
                                                                        :
                                                                        <button type="button" className="enroll-btn" disabled={true} style={{ background: 'linear-gradient(#df2c14, #c61a09)' }}>{t('course_close')}</button>
                                                            )
                                                            : ((dateCompareFunction(getServerTime, courseValue.enrollmentEndDate)) ? (<button type="button" className="enroll-btn" disabled={true} style={{ background: 'linear-gradient(#df2c14, #c61a09)' }}>{t('course_close')}</button>) : (roleId === 4 || roleId === 5 || roleId === 7)
                                                                ?
                                                                (courseValue.courseFee > 0 && roleId === 7)
                                                                    ?
                                                                    <button type="button" onClick={() => { paymentForCourse(courseId, tenantId) }} className="enroll-btn" disabled={CourseEnrollment.isLoading ? "true" : ""}>  {CourseEnrollment.isLoading ? (<> {t('loading')}</>) : (<>{t('pay_to_enroll')}</>)}</button>
                                                                    :
                                                                    ((roleId === 4) ?
                                                                        <button type="button" className="enroll-btn" onClick={() => enrollCourseHandler(userId, courseId)} disabled={true}>{t('Waiting for Admin approval')}</button>
                                                                        :
                                                                        <button type="button" className="enroll-btn" onClick={() => enrollCourseHandler(userId, courseId)} disabled={true}>{t('approval Rejected by Admin')}</button>)
                                                                :
                                                                <button type="button" className="enroll-btn" onClick={() => enrollCourseHandler(userId, courseId)} disabled={true}>{t('approval Rejected by Admin')}</button>

                                                            ))
                                                        :
                                                        (dateCompareFunction(getServerTime, courseValue.enrollmentEndDate))
                                                            ? (<button type="button" className="enroll-btn" disabled={true} style={{ background: 'linear-gradient(#df2c14, #c61a09)' }}>{t('course_close')}</button>) :
                                                            (courseValue.courseFee > 0 && roleId === 7)
                                                                ?

                                                                <button type="button" onClick={() => { paymentForCourse(courseId, tenantId) }} className="enroll-btn" disabled={CourseEnrollment.isLoading ? "true" : ""}>  {CourseEnrollment.isLoading ? (<> {t('loading')}</>) : (<>{t('pay_to_enroll')}</>)}</button>
                                                                :
                                                                ((roleId === 1)
                                                                    ?
                                                                    <button type="button" className="enroll-btn" onClick={() => enrollCourseHandler(userId, courseId)} disabled={true}>{t('already_enrolled')}</button>
                                                                    :
                                                                    ((roleId === 4 || roleId === 5) ? (roleId === 4) ? <button type="button" className="enroll-btn" disabled={true}>{t('Waiting for Admin approval')}</button> : <button type="button" className="enroll-btn" disabled={true} style={{ background: 'linear-gradient(#df2c14, #c61a09)' }}>{t('Approval Rejected by Admain')}</button> : null))
                                                }
                                                <br></br>
                                            </RenderOnAuthenticated>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Course Details */}
                {msg == null ? null :
                    <Toast show={msgshow} style={{ right: 0, backgroundColor: '#17a2b8', color: 'white', width: '300px' }} className="position-absolute top-0 end-0 m-4" onClose={() => setMsgShow(false)} delay={5000} autohide>
                        <Toast.Header style={{ fontSize: '15px' }}>
                            <i class="las la-info-circle"></i>
                            <strong className="mr-auto">{t('info')}</strong>
                            <small>{t('just_now')}</small>
                        </Toast.Header>
                        <Toast.Body >
                            {msg}
                        </Toast.Body>
                    </Toast>
                }

                <div className="course-details-area-new container">
                    <Row className="course-details-row">
                        {/* <Col className="course-detail-item">
                            <p className="label">Commencement Date:</p>
                            <h3 className="value">
                                {convertDateAndTime(courseValue.commencementDate)}
                            </h3>
                        </Col>
                        <Col className="course-detail-item">
                            <p className="label">Enrollment Dates:</p>
                            <h3 className="value">
                                {convertDate(courseValue.enrollmentStartDate)} to {convertDate(courseValue.enrollmentEndDate)}
                            </h3>
                        </Col> */}
                        <Col className="course-detail-item">
                            <p className="label">Duration:</p>
                            <h3 className="value">
                                {courseValue.duration === 1825 ? "Unlimited" : courseValue.duration} {t('days')}
                            </h3>
                        </Col>
                        <Col className="course-detail-item">
                            <p className="label">Fees:</p>
                            <h3 className="value">
                                {fee_validator(courseValue?.courseFee, courseValue?.courseType, courseValue.courseForeignFees)}
                            </h3>
                        </Col>
                    </Row>
                </div>
                <div className="course-desc-container container">
                    <div className="course-desc ">
                        <h5>{t('course_description')}</h5>
                        <p dangerouslySetInnerHTML={{ __html: courseValue.generalDetails }} style={{ textAlign: "justify" }}></p>
                    </div>
                    <div className="course-feature">
                        <h5>{t('course_prerequisite')}</h5>
                        <p dangerouslySetInnerHTML={{ __html: courseValue.prerequisite }} style={{ textAlign: "justify" }}></p>
                    </div>
                    <div className="course-feature">
                        <h5>{t('course_objective')}</h5>
                        <p dangerouslySetInnerHTML={{ __html: courseValue.objective }} style={{ textAlign: "justify" }}></p>
                    </div>
                </div>
                <div className="course-curriculum-container container">
                    <div className="course-feature">
                        <h5>Course Curriculum</h5>
                        <div className="course-element-cc">
                            {((!handleContentDependOnDate() || visibility === true) && getcourseStructure1) &&
                                getcourseStructure1.map((d, dIndex) => (
                                    <div className="course-item" key={d.key || dIndex}>
                                        <button
                                            className={`course-button ${(openModule === d.key || openModule2 === dIndex) ? "active" : ""}`}
                                            onClick={() => toggleHandlerModule(d.key, dIndex, d.nodes)}
                                        >
                                            {d.label} <span>{sumOfAllContentDuration(d.nodes)} Min</span>
                                        </button>

                                        {(visibility || roleId !== 1) ? (
                                            <div className={`course-content-cd ${(openModule === d.key || openModule2 === dIndex) ? "show" : ""}`}>
                                                <ul className="list-unstyled">
                                                    {d.nodes.map((f, i) => (
                                                        <li key={i}>
                                                            <span className="play-icon">
                                                                <i className={
                                                                    f.nodetype === "pdf" ? "fas fa-file-pdf" :
                                                                        f.nodetype === "docx" || f.nodetype === "doc" ? "fas fa-file-word" :
                                                                            f.nodetype === "html" ? "fab fa-html5" :
                                                                                f.nodetype === "txt" ? "fas fa-file-alt" :
                                                                                    f.nodetype === "scorm" ? "far fa-file-archive" :
                                                                                        f.nodetype === "youtube" ? "fab fa-youtube" :
                                                                                            (["mp4", "webm", "ogg"].includes(f.nodetype)) ? "fas fa-file-video" :
                                                                                                (["jpg", "png", "jpeg"].includes(f.nodetype)) ? "fas fa-file-image" : ""
                                                                } />
                                                                {f.label}
                                                            </span>
                                                            <span className="lecture-duration">{f.duration}:00 min</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ) : (
                                            (courseValue.courseType?.toLowerCase() === "free" || courseValue.courseType === "restricted" || feeStatus === true) && (
                                                <div className={`course-content-cd ${openModule === d.key ? "show" : ""}`}>
                                                    <ul className="list-unstyled">
                                                        {d.nodes.map((f, i) => (
                                                            <li key={i}>
                                                                <span className="play-icon">
                                                                    <i
                                                                        className={/* same icon logic */ ""}
                                                                        onClick={() => courseStructurContentView(f.nodetype, f.filePath)}
                                                                    />
                                                                    {f.label}
                                                                </span>
                                                                <span className="lecture-duration">{f.duration}:00 min</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )
                                        )}
                                    </div>
                                ))
                            }
                        </div>

                    </div>
                </div>
                <div className="course-inst-container container">
                    <div className="course-desc ">
                        <h5>Course Instructor</h5>
                        <div className='instructor-box-new'>
                            <div className="instructor-item">
                                {
                                    getInstructor?.map((data, i) => {
                                        // //console.log(data);
                                        return (
                                            <Row>
                                                <Col lg="5">
                                                    <div className="instructor-img">
                                                        <img src={`${getInstructorImg.img}${data.learnerUsername}`} alt="" className="img-fluid" style={{ width: '110px' }} />
                                                    </div>
                                                </Col>
                                                <Col lg="7">
                                                    <div className="instructor-content">
                                                        <div className="instructor-box-new">
                                                            <div className="top-content " >
                                                                {/* d-flex justify-content-between  */}
                                                                <div >
                                                                    <div className="instructor-name">
                                                                        <h6>{data?.title} {data.firstName} {data.lastName}</h6>
                                                                        <p>{courseValue.inst_profile}</p>
                                                                        <br />
                                                                        {
                                                                            UserService.isLoggedIn() &&
                                                                            <p>{t('emailid')} - {data.email}</p>
                                                                        }

                                                                    </div>
                                                                    <div className="instructor-social">
                                                                        <ul className="social list-unstyled list-inline">
                                                                            {data.facebookId === "" || data.facebookId == null ? null :
                                                                                <li className="list-inline-item" style={{ margin: 5, marginTop: 10 }}><a target="_blank" href={"https://www.facebook.com/" + data.facebookId}><i className="fab fa-facebook-f"></i></a></li>
                                                                            }
                                                                            {data.twitterId === "" || data.twitterId == null ? null :
                                                                                <li className="list-inline-item" style={{ margin: 5, marginTop: 10 }}><a href={"https://www.twitter.com/" + data.twitterId} target="_blank"><i className="fab fa"><BsTwitterX /></i></a></li>
                                                                            }
                                                                            {data.linkedinId === "" || data.linkedinId == null ? null :
                                                                                <li className="list-inline-item" style={{ margin: 5, marginTop: 10 }}><a href={"https://www.linkedin.com/in/" + data.linkedinId} target="_blank"><i className="fab fa-linkedin-in"></i></a></li>
                                                                            }
                                                                            {data.youtubeId === "" || data.youtubeId == null ? null :
                                                                                <li className="list-inline-item" style={{ margin: 5, marginTop: 10 }}><a href={"https://www.youtube.com/" + data.youtubeId} target="_blank"><i className="fab fa-youtube"></i></a></li>
                                                                            }
                                                                            {data.skypeId === "" || data.skypeId == null ? null :
                                                                                <li className="list-inline-item" style={{ margin: 5, marginTop: 10 }}><a href={"https://www.skype.com/" + data.skypeId} target="_blank"><i className="fab fa-skype"></i></a></li>
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )
                                    })
                                }
                            </div>

                        </div>
                    </div>
                </div>
                <div className="course-admission-container container">
                    <div className="course-desc ">
                        <h5>Admission Process</h5>
                        <div className="steps-container container">
                            {stepData.map((step, index) => (
                                <div className="step-item" key={index}>
                                    <img className="step-icon" src={step.icon}></img>
                                    <p>{step.label}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>



                <Modal
                    centered show={getModalState.show} onHide={() => handleModal2()}>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {t('provide_the_reply')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ReplyForm rrId={getreviewId} />
                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>
                <Modal
                    centered show={getModalState1.show} onHide={() => handleModal3()}>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {t('provide_the_reply')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UpdateReviewform reviewdata={getreviewText} starrating={getstarrate} courseid={getcourseId} ureviewid={getureviewId} learnerId={userId} tenantId={tenantId} />
                    </Modal.Body>
                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>
                <Modal
                    centered show={getModalState5.show} onHide={() => handleModal5()}>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {t('review_deleted_successfully')}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Footer>

                    </Modal.Footer>
                </Modal>
                <Modal size="md" aria-labelledby="contained-modal-title-vcenter" centered show={getAnnouncmentModal} backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {announcementData.title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {ReactHtmlParser(ReactHtmlParser(announcementData.body))}
                    </Modal.Body>
                    <Modal.Footer>
                        <span style={{ fontSize: '10px', position: 'sticky' }}>{announcementData.date}</span>
                        <Button onClick={() => setAnnouncementModal(false)}>{t('close')}</Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={getViewModalState}
                >
                    <Modal.Header>
                        {/* <Modal.Title id="contained-modal-title-vcenter">
                            
                        </Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        <iframe src={getCertificateURl} width="765px" height="800px" />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => setViewModalState(false)} className="btn btn-danger">{t('close')}</Button>
                    </Modal.Footer>
                </Modal>

                {/* ContentView model code start here*/}
                <Modal
                    size="xl" centered show={getUrlModal.show} onHide={() => UrlModalHide()} backdrop="static">
                    <Modal.Header >
                        <Modal.Title id="contained-modal-title-vcenter">
                            {getContentType === "zip" ? <i class="fas fa-file-archive" style={{ fontSize: "25px", color: "#fdbf00" }}> Zip</i>
                                : getContentType === "pdf" ? <i class="fas fa-file-pdf" style={{ fontSize: "25px", color: "#b30b00" }}> PDF</i>
                                    : getContentType === "jpg" || getContentType === "png" || getContentType === "jpeg" ? <i class="fas fa-file-image" style={{ fontSize: "25px", color: "#b2b1ff" }}> Image</i>
                                        : getContentType === "html" ? <i class="fab fa-html5" style={{ fontSize: "25px", color: "#e54c21" }}> Html</i>
                                            : getContentType === "ogg" || getContentType === "webm" || getContentType === "mp4" ? <i class="fas fa-file-video" style={{ fontSize: "25px", color: "#8cee02" }}> Video</i>
                                                // : getContentType === "txt" ? <i class="fas fa-file-alt" style={{ fontSize: "25px", color: "#2766a0" }}> Text</i>
                                                // : getContentType === "doc" || getContentType === "docx" ? <i class="fas fa-file-word" style={{ fontSize: "25px", color: "#1e62b4" }}> Doc</i>
                                                : getContentType === "scorm" ? <i class="far fa-file-archive" style={{ fontSize: "25px", color: "green" }}> Scorm</i>
                                                    : getContentType === "youtube" ? <i class="fab fa-youtube" style={{ fontSize: "25px", color: "green" }}> YouTube</i>
                                                        : null}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            getContentType === "jpg" || getContentType === "png" || getContentType === "jpeg" ? <img src={URI.SERVER?._DMS_URL + `/${getUrl}`} width="1100" height="800" />
                                : getContentType === "pdf" ? <iframe width="1100" height="800" src={URI.SERVER?._DMS_URL + `/${getUrl}`} type="application/pdf" ></iframe>
                                    : getContentType === "mp4" ? <div> <video
                                            src= {URI.SERVER?._DMS_URL + `/${getUrl}`}
                                            alt="content Video"
                                            className="img-fluid"
                                            controls
                                            controlsList="nodownload noplaybackrate"
                                            disablePictureInPicture
                                            autoPlay
                                            muted
                                            onContextMenu={(e) => e.preventDefault()}
                                            preload="metadata"
                                        /></div>
                                        // : getContentType === "docx" ? <iframe width="100%" height="100%" src={URI.SERVER?._DMS_URL+`/${getUrl}`} ></iframe>
                                        : getContentType === "html" ? <iframe width="1100" height="800" src={URI.SERVER?._DMS_URL + `/${getUrl}`} ></iframe>
                                            : getContentType === "zip" ? <iframe width="1100" height="800" src={URI.SERVER?._DMS_URL + `/${getUrl}`} ></iframe>
                                                : getContentType === "scorm" ? <iframe width="1100" height="800" src={URI.SERVER?._DMS_URL + `/${getUrl}`} ></iframe>
                                                    : getContentType === "youtube" ? <ReactPlayer url={getUrl} width="100%" height="800px" controls="true"
                                                        config={{
                                                            youtube: {
                                                                playerVars: { showinfo: 1 }
                                                            }
                                                        }}
                                                    />

                                                        : <p>{t('no_content_available')}</p>
                        }
                    </Modal.Body>
                    {/* <DiscussionMain courseid={courseId} tenantid={tenantId} userid={userId} itemid={123} /> */}
                </Modal>
                {/* ContentView model code end here*/}


                {/* Certificate Modal */}

                <Modal centered show={getPaymentParameterView.show} onHide={() => PaymentParameterViewHide()} backdrop="static" className='custom-modal-style' size="lg" >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
                            Enter payment Information to continue
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{}}>
                            <label for="name">Additional Information:</label>
                            <Table class="table table-borderless">
                                <Row>
                                    <Col style={{ marginTop: "10px" }}>

                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control"
                                            id="merchant_param1"
                                            placeholder="message"
                                            name="merchant_param1"
                                            onChange={e => setPaymentInfo({ ...getPaymentInfo, merchant_param1: e.target.value })}
                                        />
                                        <span style={{ color: "red" }}>{getPaymentInfo.merchant_param1err}</span>
                                    </Col>
                                    <Col style={{ marginTop: "10px" }}>
                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control"
                                            id="merchant_param2"
                                            placeholder="message"
                                            name="merchant_param2"
                                            onChange={e => setPaymentInfo({ ...getPaymentInfo, merchant_param2: e.target.value })}
                                        />
                                        <span style={{ color: "red" }}>{getPaymentInfo.merchant_param2err}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ marginTop: "10px" }}>
                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control"
                                            id="merchant_param3"
                                            placeholder="message"
                                            name="merchant_param3"
                                            onChange={e => setPaymentInfo({ ...getPaymentInfo, merchant_param3: e.target.value })}
                                        />
                                        <span style={{ color: "red" }}>{getPaymentInfo.merchant_param3err}</span>
                                    </Col>
                                    <Col style={{ marginTop: "10px" }}>
                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control"
                                            id="merchant_param4"
                                            placeholder="message"
                                            name="merchant_param4"
                                            onChange={e => setPaymentInfo({ ...getPaymentInfo, merchant_param4: e.target.value })}
                                        />
                                        <span style={{ color: "red" }}>{getPaymentInfo.merchant_param4err}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ marginTop: "10px" }}>
                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control"
                                            id="merchant_param5"
                                            placeholder="message"
                                            name="merchant_param5"
                                            onChange={e => setPaymentInfo({ ...getPaymentInfo, merchant_param5: e.target.value })}
                                        />
                                        <span style={{ color: "red" }}>{getPaymentInfo.merchant_param5err}</span>
                                    </Col>
                                    <Col style={{ marginTop: "10px" }}>
                                    </Col>
                                </Row>
                            </Table>
                            <br></br>
                            <label for="name">Promo code:</label>
                            <Table>
                                <Row>
                                    <Col style={{ marginTop: "10px" }}>
                                        <input
                                            type="text"
                                            maxLength={100}
                                            className="form-control"
                                            id="promo_code"
                                            placeholder="Add promo code"
                                            name="promo_code"
                                            onChange={e => setPaymentInfo({ ...getPaymentInfo, promo_code: e.target.value })}
                                        />
                                    </Col>
                                    <Col style={{ marginTop: "10px" }}>
                                    </Col>
                                </Row>
                            </Table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: "center" }}>
                        <Button variant="primary" style={{ background: 'linear-gradient(90deg, #11B67A 0%, #009444 100%)', border: '0px' }}
                            onMouseOut={changeBackgroundOut} onMouseOver={changeBackgroundOver}
                            onClick={() => { paymentForCourse(courseId, tenantId) }}
                        >
                            Proceed with payment
                        </Button>
                        <Button variant="secondary" onClick={() => PaymentParameterViewHide()} style={{ border: '0px' }}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal centered show={prerequisiteCourses.showModal} onHide={() => {
                    setPrerequisiteCourses((prev) => {
                        return {
                            showModal: false
                        }
                    })
                    window.location.reload();
                }} backdrop="static" className='custom-modal-style' size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter" style={{ alignContent: "center" }}>
                            Courses Required for Enrollment
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DataTable
                            columns={prerequisiteCourseColumn}
                            data={prerequisiteCourses?.data}
                        />
                    </Modal.Body>
                </Modal>

            </Styles>

            <LearnerCourseWiseContentWatchStatus
                userId={userId}
                courseId={courseId}
                modalStatus={showCourseSummary}
                setModalStatus={setShowCourseSummary}
            />
            <CourseSectionCD currentCourseId={courseId} handleCourseClick={handleCourseClick} courseCatagory={courseValue.categoryName} />

            {/* Footer 2 */}
            <FooterTwo />

        </div >
    )
}

export default CourseDetailsNFSUbeforeLogin
